import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export * from 'hub/components/TableOfContents/utils';

export default function TableOfContents({ headings, ...boxProps }) {
  const { t } = useTranslation('common');

  return (
    <WrapperBox as="nav" {...boxProps}>
      <TableOfContentsTitle variant="h5" component="h3">
        {t('tableOfContents.title')}
      </TableOfContentsTitle>
      <StyledList role="list">
        {headings.map(({ level, text, children, id }) => {
          return (
            <StyledListItem key={`${level}_${id}`}>
              <TypographyMainHeading
                variant="h5"
                component="a"
                href={`#${id}`}
                gutterBottom
              >
                {text}
              </TypographyMainHeading>
              {children.length ? (
                <StyledList role="list">
                  {children.map((child) => (
                    <StyledListItem key={`${child.level}_${child.id}`}>
                      <TypographySecondaryHeading
                        href={`#${child.id}`}
                        component="a"
                      >
                        {child.text}
                      </TypographySecondaryHeading>
                    </StyledListItem>
                  ))}
                </StyledList>
              ) : null}
            </StyledListItem>
          );
        })}
      </StyledList>
    </WrapperBox>
  );
}

const StyledList = styled.ul`
  text-decoration: none;
  margin: 0;
  padding: 0;

  ul {
    margin-left: 1rem;
  }
`;

const TypographyMainHeading = styled(Typography)`
  text-decoration: none;
  color: inherit;
  font-size: 14px;
`;

const TypographySecondaryHeading = styled(Typography)`
  color: ${(props) => props.theme.palette.text.secondary};
  text-decoration: none;
  font-size: 12px;
`;

const StyledListItem = styled.li`
  text-decoration: none;
  list-style-type: none;
  margin-top: 1rem;
`;

const WrapperBox = styled(Box)`
  background-color: #f8f8f8;
  padding: 1rem;
  flex-grow: 1;
`;

const TableOfContentsTitle = styled(Typography)`
  color: ${(props) => props.theme.palette.primary.main};
`;
